<template>
<div class="chapter">
<div class="inner_page">
<div id="eve-of-warfare-8.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="h2">Praise for Sylvia Day</p>
<p class="body-center"> </p>
<p class="body-center"> </p>
<p class="body-center">“You know you’re in for a good book when other authors—and I mean LOTS of other authors—recommend it.”</p>
<p class="body-center"><em>—USA Today</em></p>
<p class="body-center"> </p>
<p class="body-center">“A page-turner!”</p>
<p class="body-center"><em>—Access Hollywood Live</em></p>
<p class="body-center"> </p>
<p class="body-center">“Glamorous people, swanky settings, steamy sex, and passionate married love make this a heartwarming, gratifying conclusion to the series.”</p>
<p class="body-center"><em>—Publishers Weekly</em></p>
<p class="body-center"> </p>
<p class="body-center">“[A] highly charged story that flows and hits the mark.”</p>
<p class="body-center"><em>—Kirkus Reviews</em></p>
<p class="body-center"> </p>
<p class="body-center">“Will have you furiously flipping pages.”</p>
<p class="body-center"><em>—Glamour</em></p>
<p class="body-center"> </p>
<p class="body-center">“Sophisticated, engaging, clever and sweet.”</p>
<p class="body-center"><em>—The Irish Independent</em></p>
<p class="body-center"> </p>
<p class="body-center">“Superb writing . . . I can’t wait to see what Day does next!”</p>
<p class="body-center"><em>—RT Book Reviews</em></p>
<p class="body-center"> </p>
<p class="body-center">“When it comes to brewing up scorchingly hot sexual chemistry, Day has few literary rivals.”</p>
<p class="body-center"><em>—Booklist</em></p>
<p class="body-center"> </p>
<p class="body-center">“Day writes indulgent fantasy at its most enjoyable, in a story populated by high-society beauties and rakes, all of them hiding dark passions and darker secrets behind their glittering facades.”</p>
<p class="body-center"><em>—Shelf Awareness</em></p>
<p class="body-center"> </p>
<p class="body-center">“This bold, erotic tale of passion and revenge features a cast of colorful characters and a complex and intriguing plot.”</p>
<p class="body-center"><em>—Library Journal</em></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eveofwarfarepraise.vue?4102c186